<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{ columnValue(scope.row[j], item.moduleId) }}</template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>
  </div>
</template>


<script>
import mixin from '../mixins/enterpriseTabs'
export default {
  mixins: [ mixin ],
  name: 'businessRisk',
  data() {
    return {
      name: this.$route.query.name,
      titles: [
        { type: '', label: '经营异常', num: 0, moduleId: '' },
        { type: '', label: '非正常户', num: 0, moduleId: '' },
        { type: '', label: '行政处罚', num: 0, moduleId: '' },
        { type: '', label: '动产抵押', num: 0, moduleId: '' },
        { type: '', label: '环保处罚', num: 0, moduleId: '' },
        { type: '', label: '股权出质', num: 0, moduleId: '' },
        { type: '', label: '税收违法', num: 0, moduleId: '' },
        { type: '', label: '司法拍卖', num: 0, moduleId: '' },
        { type: '', label: '清算信息', num: 0, moduleId: '' },
        { type: '', label: '严重违法', num: 0, moduleId: '' },
        { type: '', label: '简易注销', num: 0, moduleId: '' },
        { type: '', label: '欠税公告', num: 0, moduleId: '' },
        { type: '', label: '知识产权出质', num: 0, moduleId: '' },
      ],
    }
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}
</style>
